
export default {
  props: ['data'],
  data () {
    return {
      page: 1,
      totalPages: 3
    }
  },
  computed: {
    getData () {
      return this.data.slice((this.page - 1) * this.totalPages, (this.page - 1) * this.totalPages + this.totalPages)
    }
  },
  watch: {
    page () {
      window.scrollTo(0, 0);
    }
  },
  methods: {
    ToPages (value) {
      this.$router.push(value)
    },
  }
}
